module.exports = __webpack_public_path__ + "img/Card_spade_6.cea25611.svg";